import { HEADING_COLOR, type BlockComponentProps } from "./shared"

export function ListBlock({ content, resolved }: BlockComponentProps) {
  const lh = (content?.heading as string) ?? ""
  const lItems = (content?.items as string[]) ?? []
  const listType = (content?.list_type as "unordered" | "ordered") ?? "unordered"
  const lCols = Math.min(2, Math.max(1, (content?.columns as number) ?? 1))
  if (lItems.length === 0) return null
  const ListTag = listType === "ordered" ? "ol" : "ul"
  const listClass = listType === "ordered" ? "list-decimal list-inside" : "list-disc list-inside"
  const gridClass =
    lCols === 2 ? "grid gap-2 @md:grid-cols-2 max-w-2xl mx-auto" : "max-w-2xl mx-auto"
  const listSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-6"} ${resolved.cornerClass} ${resolved.alignClass}`.trim()
    : "px-4 py-6 @sm:px-6 @md:px-8"
  return (
    <section className={listSectionClass} style={resolved.sectionStyle}>
      {lh && (
        <h2 className="text-xl font-bold mb-4" style={{ color: HEADING_COLOR }}>
          {lh}
        </h2>
      )}
      <div className={gridClass}>
        <ListTag className={listClass + " space-y-1"}>
          {lItems.filter(Boolean).map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ListTag>
      </div>
    </section>
  )
}
